import { Sticker, VariantState } from '@bytel/trilogy-react';

import { DiscountType } from '@app-types/discount';

import { formatPrice } from '@helpers/wording';

type PromoHomeStickerProps = {
    promo?: Partial<DiscountType>;
    alt?: string;
    small?: boolean;
};

export function PromoHomeSticker({ promo, alt, small = true }: Readonly<PromoHomeStickerProps>) {
    if (!promo || !promo.value) {
        return null;
    }

    return (
        <Sticker
            variant={VariantState.INFO}
            small={small}
            accessibilityLabel={alt}
            label={promo.pennant ? promo.pennant : `-${formatPrice(promo.value)}/mois déjà déduits`}
        />
    );
}
